import { CommonConstants } from '@Constants/index';
import { JWT, UserRoles } from '@Typings/auth.types';

/** Decode Access Token */
export const decodeToken = (token: string): JWT => {
  const payloadBase64 = token.split('.')[1];
  const decodedJson = Buffer.from(payloadBase64, 'base64').toString();
  return JSON.parse(decodedJson) as JWT;
};

const TokenService = {
  setUserRole: (role: UserRoles): void => {
    if (role) {
      localStorage.setItem('role', role as string);
    }
  },
  getUserRole: (): UserRoles => localStorage.getItem('role') as UserRoles,
  removeUserRole: (): void => localStorage.removeItem('role'),
  setAccessToken: (accessToken: string): void => {
    if (accessToken) {
      localStorage.setItem(
        CommonConstants.AUTH_TOKENS.ACCESS_TOKEN,
        accessToken
      );
    }
  },
  getAccessToken: (): string | null =>
    localStorage.getItem(CommonConstants.AUTH_TOKENS.ACCESS_TOKEN),
  setRefreshToken: (refreshToken: string): void => {
    if (refreshToken) {
      localStorage.setItem(
        CommonConstants.AUTH_TOKENS.REFRESH_TOKEN,
        refreshToken
      );
    }
  },
  getRefreshToken: (): string | null =>
    localStorage.getItem(CommonConstants.AUTH_TOKENS.REFRESH_TOKEN),
  removeAccessToken: (): void => {
    localStorage.removeItem(CommonConstants.AUTH_TOKENS.ACCESS_TOKEN);
  },
  removeRefreshToken: (): void => {
    localStorage.removeItem(CommonConstants.AUTH_TOKENS.REFRESH_TOKEN);
  },
  removeAllTokens: (): void => {
    TokenService.removeAccessToken();
    TokenService.removeRefreshToken();
    TokenService.removeUserRole();
  },
  isTokenExpired: (token: string): boolean => {
    const decoded = decodeToken(token);
    const { exp } = decoded;
    const expired = Date.now() >= exp * 1000;
    if (expired) {
      if (token === CommonConstants.AUTH_TOKENS.ACCESS_TOKEN) {
        TokenService.removeAccessToken();
      } else if (token === CommonConstants.AUTH_TOKENS.REFRESH_TOKEN) {
        TokenService.removeRefreshToken();
      }
    }
    return Date.now() >= exp * 1000;
  },
};

export default TokenService;
